import {Component, OnInit} from '@angular/core';

import {UtilitiesService} from '../../services/utilities.service';
import {ApiAccessService} from '../../services/network/api-access.service';
import {Router} from '@angular/router';
import {
  RealtorPortalService
} from '../../services/network/realtor-portal.service';


@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.css'],
})
export class LogInComponent implements OnInit {
  userName: string;
  password: string;
  authenticationFailed = false;
  authenticating = false;
  doBgAnimate = false;

  constructor(private realtorPortalService: RealtorPortalService,
              private router: Router) {}

  ngOnInit() {
    document.body.style.overflowX = 'hidden';
    document.body.style.overflowY = 'hidden';
    document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    document.getElementById('login-bg').style.height =
        (window.innerHeight + 100) + 'px';
    setTimeout(() => { this.doBgAnimate = true; }, 1000);

    if (ApiAccessService.isLoggedIn && ApiAccessService.userName != null &&
        UtilitiesService.isEmailValid(ApiAccessService.userName)) {
      this.userName = ApiAccessService.userName;
      this.password = ApiAccessService.password;
    }
  }

  get canLogIn() { return this.userName && this.password; }

  logIn() {
    UtilitiesService.useTestEndpoint = this.userName === 'testuser@test.com';

    this.authenticating = true;
    this.authenticationFailed = false;
    this.realtorPortalService.authenticateUser({
      UserName: this.userName,
      Password: this.password
    }).then(result => {
          if (result) {
            this.realtorPortalService.clearSideBarInfo();
            document.body.style.overflowX = '';
            document.getElementsByTagName('html')[0].style.overflow = '';
            ApiAccessService.setLoginInfo(this.userName, this.password);
            this.router.navigateByUrl('/home');
          } else {
            this.authenticationFailed = true;
          }
          this.authenticating = false;
        });
  }
}
